export default __webpack_public_path__ + "static/SectionTwo_01_04@2x-7f0423be1923cec029c8caf9088cad8f.png";